import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  border-radius: 118px;
  justify-content: space-between;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.gray0};
  font-size: 14px;
  font-weight: 600;
`;

export const LabelOption = styled.label`
  background-color: ${({ theme }) => theme.colors.gray900};
  color: ${({ theme }) => theme.colors.orange500};
  font-size: 12px;
  font-weight: 600;
  border-radius: 10px;
  padding: 2px 4px;
`;

export const Line = styled.div`
  background-color: ${({ theme }) => theme.colors.gray400};
  flex: 1;
  height: 1px;
  margin-inline: 8px;
`;

export const Switch = styled.label<{ $isSmall?: boolean; $color?: string; $isActive: boolean }>`
  position: relative;
  display: inline-block;
  width: ${({ $isSmall }) => ($isSmall ? 32 : 56)}px;
  height: ${({ $isSmall }) => ($isSmall ? 18 : 28)}px;
  background-color: ${({ theme, $isActive, $color }) =>
    $isActive ? $color || theme.colors.primaryGreen500 : theme.colors.gray500};
  box-shadow: 0 0 1px ${({ theme, $color }) => $color || theme.colors.primaryGreen200};
  cursor: pointer;
  border-radius: 9px;
  border-color: ${({ theme }) => theme.colors.gray400};
  border-width: 1px;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  .switch {
    position: absolute;
    content: '';
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${({ $isSmall }) => ($isSmall ? 14 : 22)}px;
    width: ${({ $isSmall }) => ($isSmall ? 14 : 22)}px;
    left: ${({ $isSmall }) => ($isSmall ? 2 : 2)}px;
    bottom: ${({ $isSmall }) => ($isSmall ? 1 : 2)}px;
    background-color: ${({ theme }) => theme.colors.gray0};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 7px;
    -webkit-transform: translateX(
      ${({ $isSmall, $isActive }) => $isActive && ($isSmall ? 12 : 28)}px
    );
    -ms-transform: translateX(${({ $isSmall, $isActive }) => $isActive && ($isSmall ? 12 : 28)}px);
    transform: translateX(${({ $isSmall, $isActive }) => $isActive && ($isSmall ? 12 : 28)}px);
  }

  svg {
    height: ${({ $isSmall }) => ($isSmall ? 14 : 22)}px;
    width: ${({ $isSmall }) => ($isSmall ? 14 : 22)}px;
    fill: ${({ theme, $isActive, $color }) =>
      $isActive ? $color || theme.colors.primaryGreen500 : theme.colors.gray200};
    path {
      fill: ${({ theme, $isActive, $color }) =>
        $isActive ? $color || theme.colors.primaryGreen500 : theme.colors.gray200};
    }
  }
`;
